import { FC, ReactNode, createContext } from "react";
import { ModelNames } from "../models";
import { TModelCounters } from "../filters/deprecated.types";
import usePartnerCounters, {
  initialPartnerCounts,
} from "../hooks/usePartnersCounters";
interface DashboardStoreProviderProps {
  children: ReactNode;
}

export interface DashboardStore {
  modelCounters: {
    [ModelNames.PARTNERS]: TModelCounters;
  };
}

export const initialState: DashboardStore = {
  modelCounters: {
    [ModelNames.PARTNERS]: initialPartnerCounts(),
  },
};

const DashboardContext = createContext<DashboardStore>(initialState);

export const DashboardContextProvider: FC<DashboardStoreProviderProps> = ({
  children,
}) => {
  const partnerCounters = usePartnerCounters();

  return (
    <DashboardContext.Provider
      value={{
        modelCounters: {
          [ModelNames.PARTNERS]: partnerCounters,
        },
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardContext;
